var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "faceDetectionWrapper" }, [
    _c("div", { staticClass: "textWrapper" }, [
      _vm._v(
        "\n\t\t" +
          _vm._s(
            _vm.showLoader
              ? _vm.$t("faceDetectLoading")
              : _vm.$t("faceDetectProcessing")
          ) +
          "\n\t"
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "canvasWrapper" }, [
      _vm.showLoader
        ? _c("div", [
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "loadingBar" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("canvas", { ref: "canvas" }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "buttonWrapper" }, [
      _c(
        "button",
        { staticClass: "actionbutton full", on: { click: _vm.skip } },
        [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("buttonSkip")) + "\n\t\t")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }